(function () {
  var STORAGE_KEY = 'bellabird_recently_viewed_products';
  var MAX_ITEMS = 12;

  function money(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents);
    }
    return '$' + (Number(cents || 0) / 100).toFixed(2);
  }

  function readRecent() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    } catch (e) {
      return [];
    }
  }

  function writeRecent(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items.slice(0, MAX_ITEMS)));
    } catch (e) {}
  }

  function saveCurrentProduct() {
    var el = document.querySelector('[data-bb-current-product]');
    if (!el) return;

    var product = {
      handle: el.getAttribute('data-handle'),
      title: el.getAttribute('data-title'),
      url: el.getAttribute('data-url'),
      image: el.getAttribute('data-image'),
      price: Number(el.getAttribute('data-price') || 0)
    };

    if (!product.handle || !product.title || !product.url) return;

    var items = readRecent().filter(function (item) {
      return item && item.handle !== product.handle;
    });
    items.unshift(product);
    writeRecent(items);
  }

  function renderRecentlyViewed() {
    var section = document.querySelector('[data-bb-recently-viewed]');
    if (!section) return;

    var current = section.getAttribute('data-current-handle');
    var grid = section.querySelector('[data-bb-recent-grid]');
    if (!grid) return;

    var items = readRecent().filter(function (item) {
      return item && item.handle !== current;
    }).slice(0, 8);

    if (!items.length) {
      section.hidden = true;
      return;
    }

    grid.innerHTML = items.map(function (item) {
      var img = item.image ? '<img src="' + item.image + '" alt="' + escapeHtml(item.title) + '" loading="lazy">' : '';
      return '<a class="bb-recent-card" href="' + item.url + '">' +
        '<div class="bb-recent-card__image">' + img + '</div>' +
        '<div class="bb-recent-card__title">' + escapeHtml(item.title) + '</div>' +
        '<div class="bb-recent-card__price">' + money(item.price) + '</div>' +
      '</a>';
    }).join('');

    section.hidden = false;
  }

  function escapeHtml(str) {
    return String(str || '').replace(/[&<>'"]/g, function (tag) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' })[tag];
    });
  }

  function backToTop() {
    var btn = document.querySelector('[data-bb-back-to-top]');
    if (!btn) return;

    window.addEventListener('scroll', function () {
      btn.classList.toggle('bb-back-to-top--visible', window.scrollY > 900);
    }, { passive: true });

    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    renderRecentlyViewed();
    saveCurrentProduct();
    backToTop();
  });
})();
